;(function () {
	if (!(WC?.idMenu === 175 && !WC?.idCliente)) {
		return
	}

	const bodypage = document.querySelector('.body-page')
	const banner = generateBannerNode()

	bodypage.insertBefore(banner, bodypage.querySelector('.riquadro').nextSibling)
})()

function generateBannerNode() {
	const node = document.createElement('div')

	const baseClass = 'dk-banner-agenzieimmobiliari'
	node.classList.add(baseClass)

	const image =
		WC?.PageVars?.season === 2
			? 'agenzie_immobiliari_banner_estate.jpg'
			: 'agenzie_immobiliari_banner.jpg'

	node.innerHTML = `
		<div class="${baseClass}__container">
			<a href="https://case.asiago.it/it/" target="_blank" class="${baseClass}__link">
				<figure class="${baseClass}__figure">
					<img src="/images/agenzie_immobiliari/${image}" alt="Case e appartamenti sull'Altopiano di Asiago" class="${baseClass}__image">
				</figure>
				<div class="${baseClass}__content">
					<div class="${baseClass}__btn">
						<span class="${baseClass}__text">Scopri case e appartamenti</span>
						<span class="${baseClass}__icon material-icons">keyboard_arrow_right</span>
					</div>
				</div>
			</a>
		</div>
	`

	return node
}
